"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Profile;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function Profile(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("g", {
        clipPath: "url(#clip0_944:9510)"
    }, /*#__PURE__*/ _react.createElement("path", {
        d: "M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z",
        fill: "#F3F4F6"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M32 27.9923V32.0017H0V28.007C1.86127 25.5196 4.27721 23.5008 7.05572 22.1111C9.83423 20.7213 12.8987 19.9991 16.0053 20.0017C22.544 20.0017 28.352 23.1403 32 27.9923ZM21.336 12.0003C21.336 13.4148 20.7741 14.7714 19.7739 15.7716C18.7737 16.7718 17.4172 17.3337 16.0027 17.3337C14.5882 17.3337 13.2316 16.7718 12.2314 15.7716C11.2312 14.7714 10.6693 13.4148 10.6693 12.0003C10.6693 10.5858 11.2312 9.22928 12.2314 8.22909C13.2316 7.2289 14.5882 6.66699 16.0027 6.66699C17.4172 6.66699 18.7737 7.2289 19.7739 8.22909C20.7741 9.22928 21.336 10.5858 21.336 12.0003Z",
        fill: "#D1D5DB"
    })), /*#__PURE__*/ _react.createElement("defs", null, /*#__PURE__*/ _react.createElement("clipPath", {
        id: "clip0_944:9510"
    }, /*#__PURE__*/ _react.createElement("path", {
        d: "M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z",
        fill: "white"
    }))));
}

//# sourceMappingURL=Profile.js.map